module.exports = __webpack_public_path__ + "static/shibuya-18cd7f88d6bed8dfd7d3d7ae7198f646.jpg";